function ReviewRulesService(ApiService){
  'ngInject';
  const service = {};

  service.updateReviewRules = function (addRulesForm, callbackFunc) {
    ApiService.post(`/base_review_rules.json`, { api_v1_base_review_rule: addRulesForm }, callbackFunc);
  };

  service.getReviewRules = function (callbackFunc) {
    ApiService.get(`/base_review_rules.json`, callbackFunc);
  };

  service.getAndiReviewRules = function (orgId, callbackFunc) {
    ApiService.get(`/organizations/${orgId}/andi_review_rules.json`, callbackFunc);
  };

  service.saveAndiReviewRules = function (orgId, addRulesForm, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/andi_review_rules.json`, { api_v1_andi_review_rule: addRulesForm }, callbackFunc);
  };

  service.getAccounts = function (params, callbackFunc) {
    ApiService.get(`/all_accounts.json?page=${params.page}&size=${params.size}&by_account_name=${params.search}`, callbackFunc);
  };

  return service;
}
export default {
  name: 'ReviewRulesService',
  fn: ReviewRulesService
};
